import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import useStyles from './styles';
import { selectVerifiedCode } from '../../../../../store/modules/promotion-codes/selectors';
import { SubscriptionsObject } from './types';
import { ProductCodes, Product } from '../../../../../types/products';
import { getPriceWithDiscount, getDurationPromoCodeLabel } from './utils';
import { selectProductList } from '../../../../../store/modules/products/selectors';
import { PromotionCode } from '../../../../../types/items';

type Props = {
  setPrice?: (price: number) => void;
  appliedPromoCode?: PromotionCode;
};

const CheckoutTotalField = ({ appliedPromoCode, setPrice }: Props) => {
  const classes = useStyles();
  const productList = useSelector(selectProductList);
  const subscriptionList = productList.data?.items || [];
  const { data: verifiedPromoCode } = useSelector(selectVerifiedCode);
  const promoCode = appliedPromoCode || verifiedPromoCode;
  const subscriptions: SubscriptionsObject = subscriptionList.reduce((subs, sub) => ({
    ...subs,
    [sub.product_code as ProductCodes]: sub,
  }), {} as SubscriptionsObject);

  const { watch } = useFormContext();
  const watchProductCode = watch('product_code'); // when pass nothing as argument, you are watching everything
  const currentProductCode = watchProductCode as ProductCodes;


  const currentSubscription = subscriptions[currentProductCode] as Product;
  const fullPrice = (subscriptions && currentSubscription?.cost_per_unit) || 0;
  const priceWithDiscount = promoCode ? getPriceWithDiscount(currentProductCode, promoCode, fullPrice) : fullPrice;
  const discount = (fullPrice - priceWithDiscount < 0) ? fullPrice : fullPrice - priceWithDiscount;
  const discountPeriodLabel = getDurationPromoCodeLabel(promoCode, currentSubscription);

  useEffect(() => {
    if (setPrice) {
      setPrice(priceWithDiscount);
    }
  }, [priceWithDiscount, setPrice]);

  return (
    <>
      {Boolean(discount)
      && (
        <Grid item xs={12} container justify="space-between" className={classes.discountText}>
          <div>Discount:</div>
          <div>
            $
            {discount}
          </div>
        </Grid>
      )}
      <Grid item xs={12} container justify="space-between" className={classes.totalText}>
        <div>Total:</div>
        <div>
          $
          {priceWithDiscount}
        </div>
      </Grid>
      {Boolean(discount)
      && (
        <Grid item xs={12} container justify="flex-end" className={classes.periodTipText}>
          <div>
            {discountPeriodLabel}
          </div>
        </Grid>
      )}
    </>
  );
};

export default CheckoutTotalField;
